export default {
  newInsurancePolicy: {
    id: '',
    damageTiv: '',
    damageRate: '',
    alopTiv: '',
    alopRate: '',
    damagePremium: '',
    alopPremium: '',
    damageShare: '',
    alopShare: '',
    damageBrokerage: '',
    alopBrokerage: '',
    damageTaxes: '',
    alopTaxes: '',
    damageEngFee: '',
    alopEngFee: '',
    damageFrontingFee: '',
    alopFrontingFee: '',
    damagePremiumReserve: '',
    alopPremiumReserve: '',
    damageNet: '',
    alopNet: '',
    damageNetPremium: '',
    alopNetPremium: '',
    tivTotal: '',
    rateTotal: '',
    premiumTotal: '',
    shareTotal: '',
    brokerageTotal: '',
    taxesTotal: '',
    engFeeTotal: '',
    frontingFeeTotal: '',
    premiumReserveTotal: '',
    netTotal: '',
    netPremiumTotal: '',
    effectiveDateMovement: '',
    movementEndDate: '',
  },
  increaseInsurableRisk: {
    id: '',
    movementDamage: '',
    movementAlop: '',
    movementStocks: '',
    totalDamage: '',
    totalAlop: '',
    damageTiv: '',
    damageTivMovement: '',
    damageRate: '',
    damageReserve: '',
    alopTiv: '',
    alopTivMovement: '',
    alopRate: '',
    alopReserve: '',
    damagePremium: '',
    damagePremiumSlu: '',
    alopPremium: '',
    alopPremiumSlu: '',
    damageShare: '',
    alopShare: '',
    damageBrokerage: '',
    alopBrokerage: '',
    damageTaxes: '',
    alopTaxes: '',
    damageEngFee: '',
    alopEngFee: '',
    damageFrontingFee: '',
    alopFrontingFee: '',
    damageNet: '',
    alopNet: '',
    damageNetPremium: '',
    alopNetPremium: '',
    tivTotal: '',
    tivMovementTotal: '',
    rateTotal: '',
    premiumTotal: '',
    premiumSluTotal: '',
    shareTotal: '',
    brokerageTotal: '',
    taxesTotal: '',
    engFeeTotal: '',
    frontingFeeTotal: '',
    reserveTotal: '',
    netTotal: '',
    netPremiumTotal: '',
    effectiveDateMovement: '',
    movementEndDate: '',
    premiumPaymentDate: '',
    signature: '',
    support: '',
  },
  reductionOfInsurableValue: {
    id: '',
    movementDamage: '',
    movementAlop: '',
    movementStocks: '',
    totalDamage: '',
    totalAlop: '',
    damageTiv: '',
    damageTivMovement: '',
    damageRate: '',
    damageReserve: '',
    alopTiv: '',
    alopTivMovement: '',
    alopRate: '',
    alopReserve: '',
    damagePremium: '',
    damagePremiumSlu: '',
    alopPremium: '',
    alopPremiumSlu: '',
    damageShare: '',
    alopShare: '',
    damageBrokerage: '',
    alopBrokerage: '',
    damageTaxes: '',
    alopTaxes: '',
    damageEngFee: '',
    alopEngFee: '',
    damageFrontingFee: '',
    alopFrontingFee: '',
    damageNet: '',
    alopNet: '',
    damageNetPremium: '',
    alopNetPremium: '',
    tivTotal: '',
    tivMovementTotal: '',
    rateTotal: '',
    premiumTotal: '',
    premiumSluTotal: '',
    shareTotal: '',
    brokerageTotal: '',
    taxesTotal: '',
    engFeeTotal: '',
    frontingFeeTotal: '',
    reserveTotal: '',
    netTotal: '',
    netPremiumTotal: '',
    effectiveDateMovement: '',
    movementEndDate: '',
    premiumPaymentDate: '',
    brokerage: '',
    taxes: '',
    frontingFee: '',
    engFee: '',
    signature: '',
    support: '',
  },
  movementWithoutPremium: {
    id: '',
    effectiveDateMovement: '',
    movementEndDate: '',
    pmlComments: '',
    signature: '',
    support: '',
  },
  internalAdjustment: {
    id: '',
    effectiveDateMovement: '',
    movementEndDate: '',
    pmlComments: '',
  },
  changeOfShare: {
    id: '',
    movementDamage: '',
    movementAlop: '',
    movementStocks: '',
    newShare: '',
    totalDamage: '',
    totalAlop: '',
    damageTiv: '',
    damageTivMovement: '',
    damageRate: '',
    damageReserve: '',
    alopTiv: '',
    alopTivMovement: '',
    alopRate: '',
    alopReserve: '',
    damagePremium: '',
    alopPremium: '',
    damageShare: '',
    alopShare: '',
    damageBrokerage: '',
    alopBrokerage: '',
    damageTaxes: '',
    alopTaxes: '',
    damageEngFee: '',
    alopEngFee: '',
    damageFrontingFee: '',
    alopFrontingFee: '',
    damageNet: '',
    alopNet: '',
    damageNetPremium: '',
    alopNetPremium: '',
    tivTotal: '',
    tivMovementTotal: '',
    rateTotal: '',
    premiumTotal: '',
    shareTotal: '',
    brokerageTotal: '',
    taxesTotal: '',
    engFeeTotal: '',
    frontingFeeTotal: '',
    reserveTotal: '',
    netTotal: '',
    netPremiumTotal: '',
    effectiveDateMovement: '',
    movementEndDate: '',
    premiumPaymentDate: '',
    brokerage: '',
    taxes: '',
    frontingFee: '',
    engFee: '',
    signature: '',
    support: '',
  },
  endorsementsSummary: {
    id: '',
    movementDamage: '',
    movementAlop: '',
    movementStocks: '',
    newShare: '',
    totalDamage: '',
    totalAlop: '',
    damageTiv: '',
    damageTivMovement: '',
    damageRate: '',
    damageReserve: '',
    alopTiv: '',
    alopTivMovement: '',
    alopRate: '',
    alopReserve: '',
    damagePremium: '',
    alopPremium: '',
    damageShare: '',
    alopShare: '',
    damageBrokerage: '',
    alopBrokerage: '',
    damageTaxes: '',
    alopTaxes: '',
    damageEngFee: '',
    alopEngFee: '',
    damageFrontingFee: '',
    alopFrontingFee: '',
    damageNet: '',
    alopNet: '',
    damageNetPremium: '',
    alopNetPremium: '',
    tivTotal: '',
    tivMovementTotal: '',
    rateTotal: '',
    premiumTotal: '',
    shareTotal: '',
    brokerageTotal: '',
    taxesTotal: '',
    engFeeTotal: '',
    frontingFeeTotal: '',
    reserveTotal: '',
    netTotal: '',
    netPremiumTotal: '',
    effectiveDateMovement: '',
    movementEndDate: '',
    premiumPaymentDate: '',
    brokerage: '',
    taxes: '',
    frontingFee: '',
    engFee: '',
  },
};
